module.exports = __webpack_public_path__ + "static/media/we3_social_media_marketing.e6efce29.png";